import { render } from "./learnerView.vue?vue&type=template&id=f98270a8"
import script from "./learnerView.vue?vue&type=script&lang=js"
export * from "./learnerView.vue?vue&type=script&lang=js"

import "./learnerView.vue?vue&type=style&index=0&id=f98270a8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__